import { useTranslation } from "react-i18next";
import CustomModal from "components/lib/customModal";
import { Typography } from "components/typography";
import { styled } from "styled-components";
import { Row } from "components/lib/customModal/customModal.styles";
import { Button } from "@mindlercare/ui-web";

type Props = {
  onClose: () => void;
  open: boolean;
  title: string;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const GenericMessageModal = ({
  onClose,
  open,
  title,
  onConfirm,
  isLoading,
}: Props) => {
  const { t } = useTranslation();

  return (
    <CustomModal.Wrapper onClose={onClose} open={open} size="small">
      <div>
        <Typography insensitive variant="h3" style={{ textAlign: "center" }}>
          {title}
        </Typography>
        <RowCenter>
          <Button variant="secondary" onClick={onClose}>
            {t("CANCEL")}
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            {t("CONFIRM")}
          </Button>
        </RowCenter>
      </div>
    </CustomModal.Wrapper>
  );
};

const RowCenter = styled(Row)`
  justify-content: center;
  gap: 10px;
`;
